import PaymentGatewayCommon from '@/app-core/mixins/payment/paymentGatewayCommon'
import API from '@/app-core/api/Api'
import {HmacMD5} from '@/app-core/lib/crypto/crypto'
import OtpDialog from '@/app-theme/components/common/OtpDialog.vue'

export default {
  name      : 'VivaSmartPaymentGateway',
  components: {OtpDialog},
  directives: {},
  mixins    : [PaymentGatewayCommon],
  props     : {
    model: {
      type   : Object,
      default: undefined
    }
  },
  enums    : {},
  dataStore: {
    AppCart: 'App.Cart'
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onRequestSuccess(response) {
      const data = API.responseData(response)

      if (!data?.Result?.RedirectUrl || !data?.OrderId) {
        this.loading = false
        return
      }

      this.requestSuccessNotify(response)
      this.parseRequestMessages(response)

      const storageKey = HmacMD5.hash('ORDERID')
      this.$sessionStorage.set(storageKey, data.OrderId)

      window.location.replace(data.Result.RedirectUrl)
    }
  }
}
